import { render, staticRenderFns } from "./IndicatorForm.vue?vue&type=template&id=536dd190"
import script from "./IndicatorForm.vue?vue&type=script&lang=js"
export * from "./IndicatorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports